export default __webpack_public_path__ + "static/media/price-change-gradient.bad14f05.svg";